


























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import _ from 'lodash';    
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import expandRow from './pa-so-shorted-sku-expand.vue';
class  PagePASoShortedSkuRequest extends PageRequest{
    keyword:string;
    warehouseCode :string;
}

@Component({
  components:{ expandRow }
})
export default class ViewPASoShortedSku extends mixins(ListMixin, AbpBase){
    namespace = 'paSoShortedSku';
    warehouses = [];
    //filters
    pagerequest:PagePASoShortedSkuRequest=new PagePASoShortedSkuRequest();

    get store(){
        return this.$store.state.paSoShortedSku;
    }
    isTenant() {
      return this.$store.state.session.tenant!=null;
    }
    get tenant() {
      return this.$store.state.session.tenant;
    }
     async getWarehouses(){
      await this.$store.dispatch({
            type:'warehouse/getListForSelect',
            data: { hasAllItem: true}
        }).then(()=>{
            var re = this.$store.state.warehouse.warehousesForSelect;
            this.pagerequest.warehouseCode = re.length === 0 ? "" : re[0].id;
            this.warehouses= re;
        });
    }
    
    preGetPage()
    {
        if(this.isTenant())
        {
            this.pagerequest.warehouseCode = this.tenant.tenancyName;
        }
    }
    async exportAllPASoShortedSkuToExcel()
    {
         await this.$store.dispatch({
            type: "paSoShortedSku/exportAllPASoShortedSkuToExcel",
            data: 
            { 
                keyWord: Util.isNull(this.pagerequest.keyword)?'':this.pagerequest.keyword,
                warehouseCode : this.pagerequest.warehouseCode
            }
        });
    }
    async exportAllPASoShortedSkuInfoToExcel(row:any)
    {
         await this.$store.dispatch({
            type: "paSoShortedSku/exportAllPASoShortedSkuInfoToExcel",
            data: 
            { 
                productId: row.id,
                warehouseCode : this.pagerequest.warehouseCode
            }
        });
    }
    async created(){
        await this.getWarehouses();
    }
    updated()
    {
        if(this.isTenant())
        {
            this.pagerequest.warehouseCode = this.tenant.tenancyName;
        }
    }
    columns = [
            {
                type: 'expand',
                width: 50,
                render: (h, params) => {
                    return h(expandRow, {
                        props: {
                            row: params.row
                        }
                    }   )
            
                }
            },
             {
                title: Util.L('Warehouse'),
                key: 'warehouseName'
            },
            {
                title: Util.L('Client'),
                key: 'clientName'
            },
            {
                title: Util.L('SKU'),
                key: 'sku'
            },
            {
                title: Util.L('ProductName'),
                key: 'name'
            },
            {
                title: Util.L('AssetType'),
                key: 'assetTypeName'
            },
            {
                title: Util.L('ConditionType'),
                key: 'conditionTypeName'
            },
            {
                title: Util.L('NotHasLocationQty'),
                key: 'shortQty',
                align:'right',
                render: (h, params) => {
                    return h("span", Util.toViewNumberString(params.row.shortQty))
                }
            },
            {
                title: Util.L('Action'),
                slot: 'action',
                align: 'center'
            }
    ]
}
